import React, { useEffect } from "react";
import ReactDOM from "react-dom";

export const Model = (props) => {
  const { show, children, size = "md" } = props;
  const [shouldRender, setShouldRender] = React.useState(false);
  const [isClosing, setIsClosing] = React.useState(false);

  // Prevent body scroll when modal is open
  useEffect(() => {
    if (show) {
      document.body.style.overflow = 'hidden';
      setShouldRender(true);
      setIsClosing(false);
    } else {
      setIsClosing(true);
      const timer = setTimeout(() => {
        setShouldRender(false);
        document.body.style.overflow = 'unset';
      }, 300); // 300ms matches standard transition duration
      return () => clearTimeout(timer);
    }
  }, [show]);

  // Clean up on unmount
  useEffect(() => {
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  if (!shouldRender) return null;

  const sizeClasses = {
    sm: "max-w-sm",
    md: "max-w-lg", // Default
    lg: "max-w-2xl",
    xl: "max-w-4xl",
    "2xl": "max-w-6xl",
    full: "max-w-full m-4",
  };

  const animationClass = isClosing
    ? "animate-modal-spring-out"
    : "animate-modal-spring-in";

  const backdropClass = isClosing
    ? "opacity-0"
    : "opacity-100";

  return ReactDOM.createPortal(
    <div className="fixed inset-0 z-[1050] flex items-center justify-center p-4 sm:p-6" aria-modal="true" role="dialog">
      {/* Backdrop */}
      <div
        className={`fixed inset-0 bg-dark/70 backdrop-blur-sm transition-opacity duration-300 ease-in-out ${backdropClass}`}
        onClick={() => { /* Optional: Close on backdrop click if desired */ }}
      ></div>

      {/* Modal Content */}
      <div
        className={`relative w-full bg-white rounded-2xl shadow-2xl flex flex-col max-h-[90vh] ${animationClass} ${sizeClasses[size] || sizeClasses.md}`}
        style={{ animationFillMode: 'forwards' }}
      >
        <div className="flex-1 overflow-y-auto custom-scrollbar">
          {children}
        </div>
      </div>
    </div>,
    document.body
  );
};
